import { WDD } from '../core/wdd.js';

export function videos() {
    const videos = WDD.el.querySelectorAll('video');
    const highlightsVideo = WDD.el.querySelector('.bp-highlights__video');

    const observerOptions = {
        threshold: [0, 1]
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target;

                // Special handling for highlights video - play only once
                if (video === highlightsVideo) {
                    video.play();

                    // Listen for video end and add class to nearest section
                    const handleEnded = () => {
                        const nearestSection = video.closest('.bp-section') ||
                                             video.parentElement?.closest('.bp-section');
                        if (nearestSection) {
                            nearestSection.classList.add('bp-section--video-done');
                        }
                        video.removeEventListener('ended', handleEnded);
                        observer.unobserve(video);
                    };

                    video.addEventListener('ended', handleEnded);
                    observer.unobserve(video);
                } else {
                    // Regular videos - play when visible, can play again when scrolled back
                    video.play();
                }
            }
        });
    }, observerOptions);

    // Observe all videos
    videos.forEach(v => {
        observer.observe(v);
    });
}

